import selectSingleElement from "./dom/selectSingleElement";

function checkScroll() {
	const mq = window.matchMedia("(max-width: 800px)");
	const hitElement = selectSingleElement<HTMLHeadingElement>(
		'body[class*="create-your-own"] h1, body[class*="customizer"] h1',
	);
	const imagePreview = selectSingleElement(
		'body[class*="create-your-own"] media-gallery, body[class*="customizer"] media-gallery',
	);
	const form = selectSingleElement("add-to-cart-component") as HTMLFormElement;
	const top = hitElement?.getBoundingClientRect().top ?? 0;
	const mobileTopMax = -25121;
	const mobileTopMin = -66;
	const desktopTopMax = -2154;
	const desktopTopMin = 115;

	if (imagePreview && form) {
		if (mq.matches) {
			if (top <= mobileTopMin && top >= mobileTopMax) {
				imagePreview.classList.add("scrolled");
				form.classList.add("scrolled-body");
			} else {
				imagePreview.classList.remove("scrolled");
				form.classList.remove("scrolled-body");
			}
		} else {
			if (top <= desktopTopMin && top >= desktopTopMax) {
				imagePreview.classList.add("scrolled");
				form.classList.add("scrolled-body");
			} else {
				imagePreview.classList.remove("scrolled");
				form.classList.remove("scrolled-body");
			}
		}
	}
}

export default checkScroll;
